import * as React from 'react'

function SvgBlogDesktopHeroBG(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="100%" viewBox="0 0 1440 681" fill="none" {...props}>
      <path
        d="M1440 384.575V195.633s-190.02 31.212-690.025-25.08S0 .003 0 .003v589.47s126.301 119.479 723.223 84.366C1320.14 638.726 1440 384.575 1440 384.575z"
        fill="url(#prefix__paint0_radial_desktop_hero_background_blog)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_desktop_hero_background_blog"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-933.66349 -1713.95437 2749.347 -1497.68567 755.818 1345.13)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgBlogDesktopHeroBG
